export default "__VITE_ASSET__e369cf7a__"